import { render, staticRenderFns } from "./TransactionDocuments.vue?vue&type=template&id=4981fd51"
import script from "./TransactionDocuments.vue?vue&type=script&lang=js"
export * from "./TransactionDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports